import React, { useState } from 'react';
import IntroOneHealthUI from './IntroOneHealth.presenter';

function IntroOneHealth() {
    const [numbers, setNumbers] = useState([0, 0, 0, 0]);
    return <IntroOneHealthUI numbers={numbers} setNumbers={setNumbers} />;
}

export default IntroOneHealth;
